import { forwardRef, type Ref, type SVGProps } from "react";
const IconBedroomFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M2 27a1 1 0 0 0 2 0v-4h24v4a1 1 0 0 0 2 0v-9a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zM14.5 7H6V5a1 1 0 0 0-2 0v8.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5M27 4a1 1 0 0 0-1 1v2h-8.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V5a1 1 0 0 0-1-1" /></svg>;
const ForwardRef = forwardRef(IconBedroomFilledSVG);
ForwardRef.displayName = "IconBedroomFilled";
export { ForwardRef as IconBedroomFilled };